export default {
  'pt-BR': 'BRL',
  'en-US': 'USD',
};
